<lib-infinite-scroll-header [infiniteScrollConfig]="headerConfig()"></lib-infinite-scroll-header>

<ion-item-divider sticky>
  <ion-label>
    <ion-row>
      <ion-col size="6">
        <p class="from">
          <ion-icon
            slot="start"
            aria-hidden="true"
            src="../assets/material-symbols/upload_24dp.svg"
          ></ion-icon>
          {{ 'general.origin' | translate }}
        </p>
      </ion-col>
      <ion-col
        size="6"
        class="ion-text-end"
      >
        <p class="to">
          {{ 'general.destination' | translate }}

          <ion-icon
            slot="start"
            aria-hidden="true"
            src="../assets/material-symbols/download_24dp.svg"
          ></ion-icon>
        </p>
      </ion-col>
    </ion-row>
  </ion-label>
</ion-item-divider>

<lib-freight-available-list-section
  [vm]="createdList()"
  (loadNext)="onCreatedLoadNext()"
  (retry)="onCreatedRetry()"
></lib-freight-available-list-section>

@if (hasActiveFilters()) {
  @if (createdFilteredExhausted()) {
    @if (notCreatedFilteredList().items.length > 0) {
      <div class="ion-padding">
        <strong>{{ 'market.similar_not_available' | translate }}</strong>
      </div>
      <lib-freight-available-list-section
        [vm]="notCreatedFilteredList()"
        (loadNext)="onNotCreatedLoadNext()"
        (retry)="onNotCreatedRetry()"
      ></lib-freight-available-list-section>
    }
  }
}
